import React, {Component} from 'react';
import {Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Edit2, Trash} from "react-feather";
import {Col, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Moment from "moment";
import DeleteLandingPageModal from "./modals/DeleteLandingPageModal";
import AddLandingPageModal from "./modals/AddLandingPageModal";
import AddLandingPageBrandModalForm from './modals/AddLandingPageBrandModal';
import DeleteLandingPageBrandModal from './modals/DeleteLandingPageBrandModal';
import { apiFetch, API } from "../services/api";

function getLandingPageBrands() {

    return apiFetch(API.back + '/landing-page-brands', {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function getPosts() {

    return fetch('https://back-api.therunningcollective.fr/blog-posts', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

export class LandingPageBrandsList extends Component{
    state = {
        landingPages: null,
        blogCategories: null,
        productCategories: null,
        isOpen: false,
        errors: null,
        selectedLandingPage: {
            title : "",
            description: "",
            slug: "",
            keywords: "",
            metaTitle: "",
            metaDescription: "",
            sportsCollections: {
                name: "",
                categories: []
            },
            why: {
                name: "",
                content: ""
            },
            sportsCategories: []
        }
    }

    async componentDidMount() {
        await getLandingPageBrands().then(data => {
            this.setState({ landingPages: data })
        }).catch(err =>
                console.log(err),
            this.setState({errors: "error while getting landingPageBrands"})
        );
        await getPosts().then(data => {
            this.setState({ availablePosts: data, errors : "" })
        }).catch(err =>
            this.setState({errors: "error while getting posts"})
        );
    };

    closeModal = () => this.setState({ isOpen: false, selectedLandingPage: {
            title : "",
            description: "",
            slug: "",
            keywords: "",
        } });

    render(){

        return(
            <div className="products-list">
                <Row>
                    <Col sm={11} className="products-buttons">
                        <Button className="add-product-button " variant="secondary" type="submit"onClick={(e) => this.setState({isOpen : true})}>Ajouter une landing page de marque</Button>
                    </Col>
                </Row>
                { (!this.state.landingPages) ? <p> Aucune landing page disponible.</p>
                    :
                    <Table responsive>
                        <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Description</th>
                            <th>Slug</th>
                            <th>Couverture</th>
                            <th>Produits Homme</th>
                            <th>Produits Femme</th>
                            <th>Keywords</th>
                            <th>Image sponsorisée</th>
                            <th>Disciplines</th>
                            <th>Image collections</th>
                            <th>Collections</th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.landingPages.map(landingPage => (
                            <tr key={landingPage.id}>
                                <td>{landingPage.title}</td>
                                <td>{landingPage.description}</td>
                                <td>{landingPage.slug}</td>
                                <td>
                                    <img style={{
                                        maxWidth: '100px',
                                    }} src={landingPage.backgroundImage}/>
                                </td>
                                <td>{landingPage.menCommonLink ? "OK" : "NOK"}</td>
                                <td>{landingPage.womenCommonLink ? "OK" : "NOK"}</td>
                                <td>{landingPage.bestDealsKeyword}</td>
                                <td>
                                    <img style={{
                                        maxWidth: '100px',
                                    }} src={landingPage.sponsoredImage}/>
                                </td>
                                <td>{landingPage.sportsCategories ? landingPage.sportsCategories.length : 0}</td>
                                 <td>
                                    <img style={{
                                        maxWidth: '100px',
                                    }} src={landingPage.sportsCollections.image}/>
                                </td>
                                <td>{landingPage.sportsCollections.categories ? landingPage.sportsCollections.categories.length : 0}</td>
                                <td className="table-action">
                                    <Edit2 className="align-middle mr-1" size={18} onClick={(e) => this.setState({isOpen : true, selectedLandingPage : landingPage})} style={{cursor: "pointer"}}/>
                                </td>
                                <td className="table-action">
                                    <Trash className="align-middle" size={18}onClick={(e) => this.setState({isDelete: true, selectedLandingPage: landingPage})} style={{cursor: "pointer"}}/>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                    }

                { this.state.isOpen ?
                    <AddLandingPageBrandModalForm
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpen}
                        handleSubmit={this.handleSubmit}
                        selectedLandingPage={this.state.selectedLandingPage}
                        blogCategories={this.state.blogCategories}
                        productCategories={this.state.productCategories}
                        availablePosts={this.state.availablePosts}
                    />
                    :
                    null
                }
                {this.state.isDelete ?
                    <DeleteLandingPageBrandModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isDelete}
                        handleSubmit={this.handleSubmit}
                        selectedItem={this.state.selectedLandingPage}
                        selectedCategory="landing-page"
                    />
                    :
                    null
                }
            </div>
        );

    }

}
